module.exports = __webpack_public_path__ + "media/images/site/medio_sala-d2b4bb03930ecf3be072a1096dee1ee7.jpg";